"use strict";
const createModuleInstance = require("@chiamine/bls-signatures");
module.exports = createModuleInstance;
